const isDesktop = () => {
  return window.innerWidth >= 768;
};

export default isDesktop;